import { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";

export default function FullScreenToggleButton({ fullScreen, toggleFullScreen }) {
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (fullScreen) {
      setShowTooltip(false);

      const showTimer = setTimeout(() => {
        setShowTooltip(true); // fade in
      }, 1000);

      const hideTimer = setTimeout(() => {
        setShowTooltip(false); // fade ut
      }, 5500); // totalt visningstid ~3.5 sek

      return () => {
        clearTimeout(showTimer);
        clearTimeout(hideTimer);
      };
    }
  }, [fullScreen]);

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <IconButton
        size="small"
        onClick={toggleFullScreen}
        sx={{
          animation: fullScreen ? 'softPulse 3s ease-in-out infinite' : undefined,
          filter: 'drop-shadow(0 0 2px rgba(255, 152, 0, 0))',
          '@keyframes softPulse': {
            '0%': {
              color: 'inherit',
              filter: 'drop-shadow(0 0 0 rgba(255,152,0,0))',
              transform: 'scale(1)',
            },
            '50%': {
              color: '#000',
              filter: `
                drop-shadow(1px 1px 2px rgba(255, 152, 0, 0.22))
                drop-shadow(1px -1px 2px rgba(255, 152, 0, 0.22))
                drop-shadow(-1px 1px 2px rgba(255, 152, 0, 0.22))
                drop-shadow(-1px -1px 2px rgba(255, 152, 0, 0.22))
              `,
              transform: 'scale(1.05)',
            },
            '100%': {
              color: 'inherit',
              filter: 'drop-shadow(0 0 0 rgba(255,152,0,0))',
              transform: 'scale(1)',
            },
          },
        }}
      >
        {fullScreen ? <FullscreenExitIcon fontSize="small" /> : <FullscreenIcon fontSize="small" />}
      </IconButton>

      {fullScreen && (
        <div
          style={{
            position: "absolute",
            top: -44,
            left: "50%",
            transform: showTooltip
              ? "translateX(-50%) translateY(0px)"
              : "translateX(-50%) translateY(6px)",
            backgroundColor: "rgba(0, 0, 0, 0.85)",
            color: "white",
            padding: "6px 10px",
            borderRadius: 4,
            fontSize: "0.75rem",
            whiteSpace: "nowrap",
            zIndex: 1000,
            pointerEvents: "none",
            transition: "opacity 1s ease, transform 1s ease",
            opacity: showTooltip ? 1 : 0,
          }}
        >
          Avsluta fullskärmsläge
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: "50%",
              marginLeft: "-6px",
              width: 0,
              height: 0,
              borderLeft: "6px solid transparent",
              borderRight: "6px solid transparent",
              borderTop: "6px solid rgba(0, 0, 0, 0.85)",
            }}
          />
        </div>
      )}
    </div>
  );
}
